import ScholarshipApp from "./ScholarshipApp";

export default ScholarshipApp;
